export const ROUTES = {
  AUTH: '/auth',
  LOGOUT: '/logout',
  DASHBOARD: '/',

  // Documents
  DOCUMENTS: '/documents',
  DOCUMENT_DETAIL: '/documents/:id',

  // Client Management
  CLIENT: '/client',
  CLIENT_TASK: '/client/task',
  CLIENT_EMAIL: '/client/email/:id',
  CLIENT_RULES: '/setting/rule',
  CLIENT_INTEGRATION: '/client/integration',
  CLIENT_THRESHOLDS: '/setting/thresholds',
  CLIENT_RULE_CONFIGRATION: '/client/rule_configuration'
}
